import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 74 90"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22.034 89.038.02 81.218l7.82-22.013 22.014 7.82zm-2.43-5.108 5.142-14.475-14.476-5.142-5.142 14.475zm19.14-21.892 22.014 7.82 7.82-22.014-22.015-7.82zm24.725-11.764-5.142 14.475-14.475-5.141 5.142-14.476zM43.407 22.113l22.014 7.82 7.82-22.015L51.226.098zm24.725-11.764L62.99 24.824l-14.475-5.142 5.142-14.475zM3.617 41.042l22.014 7.82 7.82-22.014-22.014-7.82zm24.725-11.764L23.2 43.753 8.725 38.611l5.142-14.475z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }